import { Directive, ElementRef } from '@angular/core';

@Directive({ selector: 'img' })
export class LazyLoadImages {
  constructor({ nativeElement }: ElementRef<HTMLImageElement>) {
    const supports = 'loading' in HTMLImageElement.prototype;

    if (supports && nativeElement.loading !== 'eager') {
      nativeElement.setAttribute('loading', 'lazy');
    }
  }
}
